module.exports = __webpack_public_path__ + "img/sbzc_06.fbf74446.jpg";